import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-4317 — true when IS_DOC_RECOGNITION_ENABLED is "true" on the server.
// Read from the public /app-config endpoint, which is how every other feature flag
// reaches the UI. The backend enforces the same flag on its routes and workers, so
// this only decides whether the surface is shown — never whether access is allowed.
export const useDocRecognitionEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isDocRecognitionEnabled ?? false;
};
